import '@/scss/main.scss'
import '@/config/svgspriteicons'
import '@/helpers/optimize-scroll-event'

import OptimizeResize from '@/helpers/optimize-resize-event'
import OptimizeScrollPerformance from '@/helpers/scroll-performance'

import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import VueTouchfeedback from 'vue-touchfeedback'

import App from '@/App.vue'
import router from '@/router'

import EventEmitter from '@/config/event-emitter.js'
import Icon from '@/components/Icon.vue'

import 'current-device'

// // import { PixiPlugin } from 'gsap/TweenMax'
//
// import 'gsap/PixiPlugin.js'
//
// // PixiPlugin()
// // require('gsap/PixiPlugin.js')

Vue.component('Icon', Icon)

Vue.use(EventEmitter)
Vue.use(VueLazyload)
Vue.use(VueTouchfeedback)

Vue.config.productionTip = false

// eslint-disable-next-line no-new
new OptimizeResize()

// eslint-disable-next-line no-new
new OptimizeScrollPerformance()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
